<div class="management-shell">
  @if (error()) {
    <div class="error-state">{{ error() }}</div>
  } @else if (customer(); as c) {
    <section class="page-hero">
      <div class="hero-main">
        <div class="entity-logo">
          @if (c.imageUrl) {
            <img [src]="c.imageUrl" [alt]="c.name" />
          } @else {
            <i class="pi pi-user"></i>
          }
        </div>
        <div>
          <span class="eyebrow">{{ isProfile() ? 'Profile' : 'Employee' }}</span>
          <h1 class="hero-title">{{ c.name || 'Unnamed Customer' }}</h1>
          <div class="hero-meta">
            <span class="chip">{{ c.corporateRole || 'No corporate role' }}</span>
            @if (c.isPhoneVerified) {
              <span class="chip">Phone verified</span>
            }
          </div>
        </div>
      </div>
      <div class="hero-actions">
        <button pButton type="button" label="Back" icon="pi pi-arrow-left" severity="secondary" [routerLink]="backLink()"></button>
        <button pButton type="button" label="Edit" icon="pi pi-pencil" [routerLink]="editLink(c)"></button>
      </div>
    </section>

    <div class="content-grid">
      <section class="panel">
        <div class="panel-header">
          <div>
            <span class="eyebrow">Customer Information</span>
            <h2>Profile details</h2>
          </div>
        </div>

        <div class="details-list">
          <div class="detail-item">
            <span class="detail-label"><i class="pi pi-envelope"></i> Email</span>
            <span class="detail-value">{{ c.emailAddress || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label"><i class="pi pi-phone"></i> Phone</span>
            <span class="detail-value">{{ c.phoneNumber || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label"><i class="pi pi-map-marker"></i> Address</span>
            <span class="detail-value">{{ c.address || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label"><i class="pi pi-building"></i> Company</span>
            <span class="detail-value">{{ c.company?.name || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label"><i class="pi pi-flag"></i> Country ID</span>
            <span class="detail-value">{{ c.countryId || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label"><i class="pi pi-star"></i> Rating</span>
            <span class="detail-value">{{ c.totalRating || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label"><i class="pi pi-calendar"></i> Date of Birth</span>
            <span class="detail-value">{{ c.dateOfBirth ? (c.dateOfBirth | date:'mediumDate') : 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label"><i class="pi pi-users"></i> Gender</span>
            <span class="detail-value">{{ c.gender === true ? 'Male' : c.gender === false ? 'Female' : 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label"><i class="pi pi-verified"></i> Phone Verified</span>
            <span class="detail-value">{{ formatBoolean(c.isPhoneVerified) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label"><i class="pi pi-key"></i> Firebase ID</span>
            <span class="detail-value">{{ c.firebaseId || 'N/A' }}</span>
          </div>
        </div>
      </section>

      <section class="panel">
        <div class="panel-header">
          <div>
            <span class="eyebrow">Access</span>
            <h2>Assigned roles</h2>
          </div>
        </div>

        <div class="chip-row">
          @for (roleName of roleNames(c); track roleName) {
            <span class="chip"><i class="pi pi-shield"></i>{{ roleName }}</span>
          } @empty {
            <div class="empty-state"><i class="pi pi-info-circle mr-2"></i>No roles are assigned.</div>
          }
        </div>
      </section>
    </div>
  } @else {
    <div class="empty-state">Loading customer...</div>
  }
</div>
